module.exports = __webpack_public_path__ + "static/img/siteInfo_map.png";